
const BlogHero = () => {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#007dff]/10 rounded-full mb-6">
            <i className="ri-book-open-line text-[#007dff]"></i>
            <span className="font-poppins text-sm font-semibold text-[#007dff]">Dijital Akademi</span>
          </div>
          
          <h1 className="font-poppins font-bold text-4xl sm:text-5xl text-gray-900 mb-6 leading-tight">
            Sigorta Dijital Akademi
          </h1>
          
          <p className="font-inter text-lg text-gray-600 leading-relaxed">
            Sigorta acentelerinin dijital dünyada başarılı olması için gerekli bilgi, strateji ve ipuçlarını paylaşıyoruz.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
